module.exports = __webpack_public_path__ + "media/images/home_page_manage_sync_options-5dce2c21fca45add86231a252f382517.png";